import { useContext } from 'react'
import { connect } from 'react-redux'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import { setCurrentFilter } from 'shared/redux/creation-filters'
import {
    resetCreationTool,
    setCreationTrimData,
    setCreationUploadInfo,
    updateCreationTool,
} from 'shared/redux/creation-tool'
import filePortalUtils from 'shared/util/file-portal-utils'
import { isVimeoUrl, isYoutubeUrl } from 'shared/util/gif-maker-util'
import urlUtils from 'shared/util/url-utils'
import { setSlideshow } from '../../gif-maker/redux/slideshow'
import { VIDEO_MIME_TYPES } from '../constants'
import { CreationToolsContext } from '../manager'
import CreationToolOutputType from '../types/output-type'

type Props = {
    apiKey?: string
    submitUrl?: string
    resetCreationTool: () => void
    setCreationUploadInfo: (submitUrl?: string, apiKey?: string) => void
    setCreationTrimData: (data: any) => void
    setCurrentFilter: (filter: any) => void
    updateCreationTool: (data: any) => void
    setSlideshow: (files: any) => void
}

const CreationToolsLegacyFile = ({
    apiKey,
    submitUrl,
    resetCreationTool,
    setCurrentFilter,
    updateCreationTool,
    setCreationUploadInfo,
    setCreationTrimData,
    setSlideshow,
}: Props) => {
    const { sources, outputType } = useContext(CreationToolsContext)

    useAsyncEffect(async () => {
        resetCreationTool()
        setCurrentFilter({})
        if (sources.length && outputType !== CreationToolOutputType.Sticker) {
            const mainSource = sources[0]
            const { duration, source } = mainSource
            let data = {}
            let isVideo = false
            let isVideoEmbed = false

            if (typeof source === 'string') {
                const isYoutube = isYoutubeUrl(source)
                const isVimeo = isVimeoUrl(source)
                const mediaType = urlUtils.mediaType(source)
                isVideo = isYoutube || isVimeo || mediaType === 'video'
                isVideoEmbed = isYoutube || isVimeo
                data = {
                    file: source,
                    preview: source,
                    fileType: isYoutube ? 'youtube' : isVimeo ? 'vimeo' : mediaType,
                    type: 'url',
                    id: mainSource.id,
                }
            } else {
                isVideo = VIDEO_MIME_TYPES.indexOf(source.type) > -1
                data = {
                    file: source,
                    fileType: isVideo ? 'video' : 'image',
                    type: 'file',
                    id: mainSource.id,
                }
            }

            const previewData = await filePortalUtils.generatePreview(data)
            const file = { ...data, ...previewData }
            setSlideshow([file])
            updateCreationTool({ file })
            setCreationUploadInfo(submitUrl, apiKey)
            setCreationTrimData({ duration: Math.round(duration * 1000), startFrame: 0, isVideoEmbed })
        }
    }, [sources])

    return null
}

export default connect(null, {
    updateCreationTool,
    setCreationUploadInfo,
    resetCreationTool,
    setCurrentFilter,
    setCreationTrimData,
    setSlideshow,
})(CreationToolsLegacyFile)
